/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoard from './tumor-board';
import TumorBoardDetail from './tumor-board-detail';
import TumorBoardUpdate from './tumor-board-update';
import TumorBoardDeleteDialog from './tumor-board-delete-dialog';

const TumorBoardRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoard />} />
    <Route path="new" element={<TumorBoardUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardDetail />} />
      <Route path="edit" element={<TumorBoardUpdate />} />
      <Route path="delete" element={<TumorBoardDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardRoutes;
